import type { GeneratedInsight } from "@amzn/d16-g-client-deck-builder-typescript-client";
import { HelpTip } from "@amzn/storm-ui";
import React from "react";
import { useNavigate } from "react-router-dom";
import { isTruthy } from "remeda";

import { TELEMETRY_ID } from "../../../../../constants/telemetry";
import { logWithTakt } from "../../../../../utils/telemetry.utils";
import { getSearchParamsAndOverride } from "../../../../../utils/url.utils";
import { ToolbarButton } from "../../../../common/styled.components";

export const EditInputsButton: React.FunctionComponent<{
    insight: GeneratedInsight;
}> = ({ insight }) => {
    const navigate = useNavigate();
    const domain = insight?.domainIdentifier;
    const template = insight?.templateIdentifier;
    const identifier = insight?.identifier;

    const isEnabled = React.useMemo(() => {
        return isTruthy(domain && template && identifier);
    }, []);

    const handleEditInputs = () => {
        if (isEnabled) {
            logWithTakt(TELEMETRY_ID.IHUB_CUSTOM_INSIGHTS_CLONE, {
                domainIdentifier: domain,
                templateIdentifier: template,
                identifier,
            });
            navigate({
                pathname: `/domains/${domain}/templates/${template}`,
                search: getSearchParamsAndOverride({
                    getPayloadFromInsight: identifier as string,
                }),
            });
        }
    };

    if (isEnabled) {
        return (
            <ToolbarButton
                data-testid="cdb-deep-link-insights"
                onClick={() => {
                    handleEditInputs();
                }}
            >
                Clone
                <HelpTip>Recreate this insight with new inputs</HelpTip>
            </ToolbarButton>
        );
    } else {
        return <></>;
    }
};
